import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { MIRAGE, WHITE, FONTS, CENTER, MEDIA_QUERIES } from '../styles';
import { css, StyleSheet } from 'aphrodite/no-important';
import Button, { TYPES } from '../components/Button';
import Text, { getTranslation } from '../components/Text';
import Wrapper from '../components/Wrapper';
import { isAuthenticated, logoutAction } from '../redux/user';
import { getPathname } from '../redux/app';
import { connect } from 'react-redux';
import Link from '../components/Link';
import { BASENAME } from '../config';

export const HEADER_HEIGHT_MOBILE = 84;
export const HEADER_HEIGHT_DESKTOP = 50;

const s = StyleSheet.create({
  root: {
    height: HEADER_HEIGHT_MOBILE,
    [MEDIA_QUERIES.ON_DESKTOP]: {
      height: HEADER_HEIGHT_DESKTOP,
    },
  },
  header: {
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 2,
    display: 'flex',
    justifyContent: CENTER,
    alignItems: 'flex-end',
    width: '100%',
    backgroundColor: MIRAGE,
    color: WHITE,
    height: HEADER_HEIGHT_MOBILE,
    [MEDIA_QUERIES.ON_DESKTOP]: {
      height: HEADER_HEIGHT_DESKTOP,
      alignItems: CENTER,
    },
  },
  headerWrapper: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingBottom: 20,
    [MEDIA_QUERIES.ON_DESKTOP]: {
      paddingBottom: 0,
    },
  },
  title: {
    ...FONTS.BOLD,
    fontSize: 16,
    color: WHITE,
    padding: 0,
    marginRight: 10,
    display: 'inline-block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  logo: {
    width: 20,
    marginRight: 10,
  },
  logoWrapper: {
    display: 'flex',
    marginRight: 10,
    alignItems: 'center',
    textDecoration: 'none',
  },
  hideOnMobile: {
    display: 'none',
    [MEDIA_QUERIES.ON_DESKTOP]: {
      display: 'block',
    },
  },
  noPaddinOnMobile: {
    marginRight: 0,
    [MEDIA_QUERIES.ON_DESKTOP]: {
      marginRight: 10,
    },
  },
  buttonIcon: {
    marginRight: 10,
    display: 'inline-block',
    verticalAlign: 'sub',
  },
});

const basePaths = ['/login', '/'];

const NavigationButton = ({ messageId, to }) => (
  <Button
    component={Link}
    transformer={(txt) => txt.toUpperCase()}
    to={to}
    messageId={messageId}
    iconName="arrow-right"
    __className={s.title}
    __iconClassName={s.buttonIcon}
    __type={TYPES.TRANSPARENT}
  />
);

NavigationButton.propTypes = {
  messageId: PropTypes.string,
  to: PropTypes.string,
};

const BreadCrumbNavigation = ({ breadcrumbs }) =>
  breadcrumbs
    .filter(Boolean)
    .map((config, i) => (
      <NavigationButton {...config} key={`navigation-${i}`} />
    ));

BreadCrumbNavigation.propTypes = {
  messageId: PropTypes.string,
  to: PropTypes.string,
};

const Header = ({ pathname, title }) => {
  useEffect(() => {
    document.title = [
      getTranslation('page.title'),
      ...(title || []).map((data) => data && getTranslation(data.messageId)),
    ]
      .filter(Boolean)
      .join(' | ');
  }, [title]);

  return (
    <div className={css(s.root)}>
      <div className={css(s.header)}>
        <Wrapper>
          <header className={css(s.headerWrapper)}>
            <Link to={BASENAME + '/'} className={css(s.logoWrapper)}>
              <img
                alt="logo"
                src={require('../assets/logo.svg')}
                className={css(
                  s.logo,
                  !basePaths.includes(pathname) && s.noPaddinOnMobile
                )}
              />
              <Text
                messageId="app.name"
                className={css(
                  s.title,
                  !basePaths.includes(pathname) && s.hideOnMobile
                )}
              />
            </Link>
            <BreadCrumbNavigation
              breadcrumbs={Array.isArray(title) ? title : [title]}
            />
          </header>
        </Wrapper>
      </div>
    </div>
  );
};

Header.propTypes = {
  pathname: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
};

const mapStateToProps = (state) => ({
  isAuthenticated: isAuthenticated(state),
  pathname: getPathname(state),
});

const mapDispatchToProps = (dispatch) => ({
  logOut: () => dispatch(logoutAction()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
